var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 8,
    viewBox: "0 0 8 8",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.758321 3.88503c-.288381-.33044-.254288-.83209.076148-1.12047l2.911761-2.541178c.29916-.2610788.74517-.2610788 1.04432 0l2.91177 2.541178c.33043.28838.36453.79003.07615 1.12047-.28838.33043-.79003.36453-1.12047.07614l-1.59549-1.39242v4.60588c0 .43858-.35554.79412-.79412.79412s-.79411-.35554-.79411-.79412v-4.60588l-1.59549 1.39242c-.33044.28839-.83209.25429-1.120469-.07614z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.0d2f59e356a0a64ad45d56ca7e076f83.svg";